import React, { useState } from 'react'
import { Button, Dialog } from '@material-ui/core'
import { COLORES } from '../../../config/colores'
import DialogView from '../../Dialogos/DialogView'

function TableValueAction (props) {
    const { value, title, content, textColor = null , backgroundColor = null} = props
    const [ open, setOpen ] = useState(false)

    const handleOpen = () => {        
        setOpen(true)
    }

    const handleClose = () => {       
        setOpen(false)       
    }

    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}                
                maxWidth='xl'
                fullWidth={true}
            >
                <DialogView
                   cancelCallback={handleClose}
                   title={title}
                   content={content}
                />
            </Dialog>

            <Button
                variant='text'
                style={{ 
                    color: textColor ? textColor : COLORES.grey.dark , 
                    justifyContent:'flex-start',
                    backgroundColor: backgroundColor ? backgroundColor : 'none',
                    fontSize:'1rem', 
                    width: '100%', 
                    padding:0,
                    fontWeight: 'bold', 
                    outline:'none',
                    borderRadius: '8px',
                    cursor:'none'
                    
                }}
                size='small'
                onClick={handleOpen}
            >
                {value}
            </Button>
        
        </>
    )
}

export default TableValueAction